module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "content-chapter1",
    attrs: {
      "id": "calibre_toc_9",
      "xml:lang": "en-GB"
    }
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/OEBPS/ebook_split_006#_idTextAnchor002"
    }
  }, [_vm._v("Introduction"), _c('span', {
    staticClass: "calibre4",
    attrs: {
      "id": "_idTextAnchor044"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-textx"
  }), _vm._v(" "), _c('p', {
    staticClass: "structue-q"
  }, [_vm._v("“The law of attraction states that whatever you focus on, think about, read about, and talk about intensely, you’re going to attract more of into your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "quote-author"
  }, [_vm._v("—Jack Canfield")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_19"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6310419a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_010.vue
// module id = 84
// module chunks = 0